<template>
  <div class="container flex">
    <div class="topnav">
      <el-radio-group v-model="radio1" v-for="(item, index) in typeList" size="medium" :key="index">
        <el-radio-button v-if="index > 0" :label="item.mc_name" type="primary" class="ml10 mt10">{{ item.mc_name }}</el-radio-button>
      </el-radio-group>
    </div>
    <div id="test" class="flex mt10 ml10">
      <div class="leftNav flex1">
        <div style="width: 98%">
          <el-input placeholder="请输入名称查询" clearable v-model="company" @blur="searchcomp" prefix-icon="el-icon-search"></el-input>
        </div>
        <div style="height: 92%; overflow: auto">
          <el-menu default-active="2" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose">
            <el-submenu :index="String(index)" v-for="(item, index) in companyList1.length ? companyList1 : companyList">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index)}-${String(ind)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="content" @dblclick="submit">
        <!-- <div></div> -->

        <div
          class="canvas"
          ref="can1"
          :style="{
            transform: 'scale(' + num + ')',
            position: 'relative',
            height: '100%',
            width: '100%',
          }"
          @mousewheel="suo"
          @mousedown="moveMouse"
          v-if="dwImg"
        >
          <img :src="dwImg" ref="lwimg" alt="" />
        </div>
      </div>
      <div class="rightnav flex1">
        <el-table :data="qvyuList" class="mt10">
          <el-table-column prop="number" label="部位号" align="center"> </el-table-column>
          <el-table-column prop="true_addr" label="部位名称" align="center"> </el-table-column>

          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" icon="el-icon-edit" @click="markp(scope.row, scope.$index)"></el-button>

              <el-popconfirm title="确定删除此点位吗？" class="cursor" @confirm="cancle(scope.row)" @onConfirm="cancle(scope.row)">
                <a slot="reference" class="red">
                  <el-button type="danger" icon="el-icon-delete" size="mini"></el-button>
                </a>
              </el-popconfirm>
              <el-button size="mini" type="info" icon="el-icon-video-camera" plain @click="markp(scope.row, scope.$index, true)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog :title="videoAddr + '点位摄像头'" width="80%" :visible.sync="comara">
      <!-- <video width="400" height="200" :src="'https://open.ys7.com/ezopen/h5/iframe_se?url='+item.vUrl" controls></video> -->
      <!-- <div style="height:330px">
                                <iframe :src="`https://open.ys7.com/ezopen/h5/iframe?url=${item.vUrl}`" width="100%" height="100%" allowfullscreen >
                            </iframe>
                           </div> -->
      <div style="height:400px">
        <div v-if="videoList.length" style="height:100%;overflow:auto">
          <el-col :span="10" v-for="(item, index) in videoList" :key="index" class="mt20 ml20 relative ">
            <div style="height:330px" v-if="item.vUrl && item.name == '海康萤石云'">
              <iframe :src="`https://open.ys7.com/ezopen/h5/iframe?url=${item.vUrl}`" width="100%" height="100%" allowfullscreen> </iframe>
            </div>
          </el-col>
        </div>
        <div class="center" v-else>
          <span>暂无数据</span>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
import { getMapByid } from "../../api/common";

export default {
  components: {},
  data() {
    return {
      num: 1,
      isdraged: true,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: "", // 当前查询的公司
      companyList: [], //公司列表
      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      comara: false, //点位摄像头
      videoList: [], // 摄像头列表
      selectPoint: {}, // 选中的点位
      selectcomp: "",
      videoAddr: "",
      form: {}, //最终确定的点位
      dwImg: "",
      radio1: "",
    };
  },
  watch: {
    isdraged(val) {
      if (!val) {
        // this.$message.warning('选择点位标注')
        this.setQuery("block");
      } else {
        this.getdwList();

        // this.$message.warning('退出点位标注')
        // this.setQuery('none')
      }
    },
  },
  created() {
    // 登录状态下不会出现这行文字，点击页面右上角一键登录
    getMapByid(175).then((res) => {
      this.typeList = res.data;
    });
    // 获取单位
    this.$post("/crt/crtmenu", { type: 1 }).then((res) => {
      this.companyList = res.data;
    });
    this.clearPoint(1);
  },
  mounted() {
    // 登录状态下不会出现这行文字，点击页面右上角一键登录
    // 登录状态下不会出现这行文字，点击页面右上角一键登录
    //         var canvasColor = document.getElementById('canvasColor');
    // var contextColor = canvasColor.getContext('2d');
    // console.log(contextColor)
    // contextColor.fillStyle = 'RGB(255, 0, 0)';
    // contextColor.fillRect(10, 10, 100, 100);
  },
  methods: {
    viewcamra(it) {
      this.videoAddr = it.true_addr;
      this.videoList = [];

      this.comara = true;
      this.getVideoList(it);
    },
    // 获取监控列表
    getVideoList(it) {
      this.$post("/crt/crtkind", { point_uuid: it.point_uuid }).then((res) => {
        if (res.data.length) {
          this.getYS(res.data);
        }
      });
    },
    // 获取萤石云的摄像头
    getYS(arr) {
      console.log(this.videoList);
      this.$get("basevideo/videotoken").then((Res) => {
        arr.map((item) => {
          // 如果是海康萤石云 获取网址 赋值iframe
          if (item.name === "海康萤石云") {
            item.vUrl = `ezopen://open.ys7.com/${item.number}/1.live&accessToken=${Res.data}`;
            item.turn = 0;
          }
          this.videoList.push(item);
        });
      });
    },
    // 看坐标
    setQuery() {
      var name = this.isdraged ? "none" : "block";
      const markers = document.querySelectorAll(".g-image-op");
      for (var i = 0; i < markers.length; i++) {
        markers[i].style.display = name;
      }
    },
    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
    },
    //提交
    submit() {
      // return
      if (this.form.point_uuid) {
        var obj = {
          point_uuid: this.form.point_uuid,
          x_axis: this.form.position.x,
          xa_axis: this.form.position.x1,
          y_axis: this.form.position.y,
          ya_axis: this.form.position.y1,
        };
        this.$post("crt/crtupdatedot", obj).then((res) => {
          this.$message.success("标点成功");
          this.form = {};
          this.isdraged = !this.isdraged;

          this.selectPoint = false;
        });
      } else {
        this.isdraged = !this.isdraged;
      }
    },

    //取消标点
    cancle(it) {
      var obj = {
        point_uuid: it.point_uuid,
        x_axis: "",
        xa_axis: "",
        y_axis: "",
        ya_axis: "",
      };
      this.$post("crt/crtupdatedot", obj).then((res) => {
        // this.$message.success("删除成功");
        this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
        // this.isdraged = true;
        this.getdwList();
      });
    },
    // 标点
    markp(it, ind, camra) {
      // var data = null
      this.add = false;
      var add = this.add;
      this.pointList.map((item) => {
        if (item.point_uuid === it.point_uuid) {
          this.selectPoint = item;
          if (!item.position.x1 || !item.position.y1) {
            //需要新增
            add = true;
            this.form = {};
          }
        }
      });
      if (!add) {
        // 不需要新增，将选择的点位放置列表中显示
        // this.pointList = [this.selectPoint];
        this.add = add;
        this.clearPoint();
        this.form = {};
        this.form = this.selectPoint;
        this.setPoint([this.selectPoint]);
      } else {
        //需要新增
        // this.getPoint()
        this.clearPoint();
        this.add = add;
        this.selectPoint = {
          tag: it.number,
          tagName: `部位编号：${it.number} 
                        部位名称：${it.true_addr}`,
          point_uuid: it.point_uuid,
        };
        // this.selectPoint = {
        //   uuid: it.uuid,
        // };
      }

      this.isdraged = false;
      this.setQuery();
      if (camra) {
        this.viewcamra(it, ind);
      }
    },
    getPoint() {
      this.$refs["aiPanel-editor"].getMarker().clearData();
      this.$refs["aiPanel-editor"].getMarker().renderData(this.pointList);
    },

    setPoint(point) {
      this.$refs["aiPanel-editor"].getMarker().renderData(point);
    },
    clearPoint() {
      this.$refs["aiPanel-editor"].getMarker().clearData();
    },
    //获取点位
    getdwList() {
      this.$post("/crt/crtright", { area_uuid: this.selectcomp }).then((res) => {
        var companylist = [];
        var pointList = [];

        res.data.map((item) => {
          var obj1 = {
            number: item.number,
            true_addr: item.true_addr,
            point_uuid: item.point_uuid,
          };
          var obj2 = {
            tag: item.number,
            tagName: `部位编号:${item.number} 
                        部位名称:${item.true_addr}`,
            position: {
              x: item.x_axis,
              x1: item.xa_axis,
              y: item.y_axis,
              y1: item.ya_axis,
            },
            point_uuid: item.point_uuid,
          };
          companylist.push(obj1);
          pointList.push(obj2);
        });
        this.qvyuList = companylist;
        this.pointList = pointList;
        this.getPoint();
      });
    },

    // 选择区域的点
    checkCop(it) {
      this.selectcomp = it.area_uuid;
      console.log(it);
      this.dwImg = it.image_name;
      console.log(this.dwImg);
      this.getdwList();
    },

    //准备完成时
    ready() {
      // console.log(this.pointList)
    },
    //更新时
    update(v) {
      if (!this.add && this.selectPoint.point_uuid) {
        // 新增的变化
        this.form = {};
        this.form = { ...this.selectPoint, ...v[0] };
      } else {
      }
    },
    //添加标点时
    added(v) {
      if (this.add) {
        // 新增的变化

        this.$refs["aiPanel-editor"].setTag(this.selectPoint);
        this.add = false;
        this.form = {};
        this.form = { ...v, ...this.selectPoint };
      } else {
      }
    },
    //选中标点时
    selected(v) {
      this.isdraged = false;
      this.selectPoint = v;
      this.form = this.selectPoint;
    },
    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    //列表关闭是
    handleClose() {},
    // 列表展开是
    handleOpen() {},
    // 拖拽 目前还未使用
    moveMouse(e) {
      if (this.isdraged) {
        let odiv = this.$refs.can1; //获取目标元素
        //算出鼠标相对元素的位置
        let disX = e.clientX - odiv.offsetLeft;
        let disY = e.clientY - odiv.offsetTop;
        document.onmousemove = (e) => {
          //鼠标按下并移动的事件
          //用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
          let left = e.clientX - disX;
          let top = e.clientY - disY;

          //绑定元素位置到positionX和positionY上面
          this.positionX = top;
          this.positionY = left;

          //移动当前元素
          odiv.style.left = left + "px";
          odiv.style.top = top + "px";
        };
        document.onmouseup = (e) => {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}

.imgcanvas {
  width: 100%;
  position: absolute;
  // background: pink;
}

.canvas {
  display: flex;
  align-items: center;
}
.container {
  height: 92%;
  flex-direction: column;
  .topnav {
    height: 20%;
  }
  .leftNav {
    height: 100%;
  }
  #test {
    border-top: 1px solid #ddd;
    height: 80%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 50%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      margin: 0 auto;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
</style>
